import { MuiThemeProvider } from "@material-ui/core";
import { useState } from "react";
import cookiesProvider from "../cookies-provider";
import { storageProvider } from "../storage-provider";
import { AppContext } from "./app.context";
import { calcStarterTheme } from "./calc-theme";

export const AppContextProvider = ({ children }) => {

    const lsContext = storageProvider.getCurrentContext()

    const lsProduct = lsContext?.product;
    const lsUserContext = lsContext?.user_context;
    const lsCurrentUser = lsUserContext?.user;
    const lsProfile = lsUserContext?.profile
    const lsPermissions = lsUserContext?.profile.permissions;
    const lsInstitutionBranch = lsUserContext?.institution_branch
    const lsFavoriteThemes = lsUserContext?.favorite_themes
    const lsProducts = lsInstitutionBranch?.institution?.products
    const lsContexts = lsContext?.contexts

    const preferredTheme = cookiesProvider.getPreferredTheme()

    const lsSchoolStudentTutorialCompletion = lsCurrentUser?.schoolStudentTutorialCompletion
    const lsSchoolManagerTutorialCompletion = lsCurrentUser?.schoolManagerTutorialCompletion
    const lsOfficeStudentTutorialCompletion = lsCurrentUser?.officeStudentTutorialCompletion
    const lsOfficeManagerTutorialCompletion = lsCurrentUser?.officeManagerTutorialCompletion

    const [id, setId] = useState(lsUserContext?.id)
    const [currentUser, setCurrentUser] = useState(lsCurrentUser)
    const [permissions, setPermissions] = useState(lsPermissions)
    const [product, setProduct] = useState(lsProduct)
    const [products, setProducts] = useState(lsProducts)
    const [theme, setTheme] = useState(calcStarterTheme(lsProduct, preferredTheme))
    const [institutionBranch, setInstitutionBranch] = useState(lsInstitutionBranch)
    const [profile, setProfile] = useState(lsProfile)
    const [contexts, setContexts] = useState(lsContexts)
    const [favoriteThemes, setFavoriteThemes] = useState(lsFavoriteThemes)

    const [schoolStudentTutorialCompletion, setSchoolStudentTutorialCompletion] = useState(lsSchoolStudentTutorialCompletion)
    const [schoolManagerTutorialCompletion, setSchoolManagerTutorialCompletion] = useState(lsSchoolManagerTutorialCompletion)
    const [officeStudentTutorialCompletion, setOfficeStudentTutorialCompletion] = useState(lsOfficeStudentTutorialCompletion)
    const [officeManagerTutorialCompletion, setOfficeManagerTutorialCompletion] = useState(lsOfficeManagerTutorialCompletion)

    const clearContext = () => {
        setId(undefined)
        setContexts([])
        setCurrentUser({})
        setPermissions([])
        setProduct({})
        setProducts([])
        setInstitutionBranch({ institution: {} })
        setProfile({})
        setFavoriteThemes([])
        setSchoolStudentTutorialCompletion([])
        setSchoolManagerTutorialCompletion([])
        setOfficeStudentTutorialCompletion([])
        setOfficeManagerTutorialCompletion([])
    }

    const setContext = (data) => {
        const product = data.product;
        const userContext = data.context;
        const currentUser = userContext.user;
        const profile = userContext.profile;
        const permissions = userContext.profile.permissions;
        const institutionBranch = userContext.institution_branch;
        const products = institutionBranch.institution.products;
        const favoriteThemes = userContext.favorite_themes;
        const schoolStudentTutorialCompletion = currentUser.schoolStudentTutorialCompletion;
        const schoolManagerTutorialCompletion = currentUser.schoolManagerTutorialCompletion;
        const officeStudentTutorialCompletion = currentUser.officeStudentTutorialCompletion;
        const officeManagerTutorialCompletion = currentUser.officeManagerTutorialCompletion;

        setId(userContext.id)
        setCurrentUser(currentUser)
        setPermissions(permissions)
        setProduct(product)
        setProducts(products)
        setInstitutionBranch(institutionBranch)
        setProfile(profile)
        setTheme(calcStarterTheme(product))
        setFavoriteThemes(favoriteThemes)
        setSchoolStudentTutorialCompletion(schoolStudentTutorialCompletion)
        setSchoolManagerTutorialCompletion(schoolManagerTutorialCompletion)
        setOfficeStudentTutorialCompletion(officeStudentTutorialCompletion)
        setOfficeManagerTutorialCompletion(officeManagerTutorialCompletion)
    }

    return (
        <AppContext.Provider value={
            {
                id,
                currentUser, setCurrentUser,
                permissions, setPermissions,
                product, setProduct,
                products, setProducts,
                contexts, setContexts,
                theme, setTheme,
                favoriteThemes, setFavoriteThemes,
                institutionBranch, setInstitutionBranch,
                profile, setProfile,
                schoolStudentTutorialCompletion, setSchoolStudentTutorialCompletion,
                schoolManagerTutorialCompletion, setSchoolManagerTutorialCompletion,
                officeStudentTutorialCompletion, setOfficeStudentTutorialCompletion,
                officeManagerTutorialCompletion, setOfficeManagerTutorialCompletion,
                clearContext,
                setContext,
            }
        }>
            <MuiThemeProvider theme={theme}>
                {children}
            </MuiThemeProvider>
        </AppContext.Provider>
    )

}